import moment from "moment";

import { i18n } from "@/i18n";
import store from "@/store/store";
import fileDownload from "js-file-download";

export default {
  capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },
  capitalize(str) {
    return str.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
  },
  downloadFile(data, file_name) {
    return fileDownload(data, file_name);
  },
  getRandomColor() {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }

    return color;
  },
  checkInternationalDeliveryAvailability() {
    var now = moment();
    var hourToCheck = 13; // 1pm
    var dateToCheck = now.hour(hourToCheck);

    if (now.day() == 0) {
      return false;
    } //Sunday
    if (now.day() == 6) {
      return false;
    } // Saturday

    return !moment().isAfter(dateToCheck);
  },
  checkIsAfter(date1, date2) {
    return moment(date1).isAfter(date2);
  },
  removeUnderScore(sentence) {
    return sentence.replace(/_/g, " ");
  },
  renderTodayDate(format) {
    return moment
      .tz(store.getters.getUserCountry ? store.getters.getUserCountry.timezone_name : "Asia/Singapore")
      .format(format ? format : "D-M-YYYY");
  },
  renderDateByFormat(datetime, prev_format, new_format) {
    return moment(datetime, prev_format).format(new_format);
  },
  renderTimezoneByFormat(datetime, format) {
    return moment
      .utc(datetime)
      .tz(store.getters.getUserCountry ? store.getters.getUserCountry.timezone_name : "Asia/Singapore")
      .format(format);
  },
  renderHourByTimezone(datetime) {
    return moment
      .utc(datetime)
      .tz(store.getters.getUserCountry ? store.getters.getUserCountry.timezone_name : "Asia/Singapore")
      .format("h a");
  },
  renderDateByTimezone(datetime) {
    return moment
      .utc(datetime)
      .tz(store.getters.getUserCountry ? store.getters.getUserCountry.timezone_name : "Asia/Singapore")
      .format("D-M-YYYY");
  },
  renderDateOnly(datetime) {
    return moment
      .utc(datetime)
      .tz(store.getters.getUserCountry ? store.getters.getUserCountry.timezone_name : "Asia/Singapore")
      .format("YYYY-MM-DD");
  },
  renderDateTimeByTimezone(datetime) {
    return moment
      .utc(datetime)
      .tz(store.getters.getUserCountry ? store.getters.getUserCountry.timezone_name : "Asia/Singapore")
      .format("lll");
  },
  renderDateTimeFormatByTimezone(datetime) {
    return moment
      .utc(datetime)
      .tz(store.getters.getUserCountry ? store.getters.getUserCountry.timezone_name : "Asia/Singapore")
      .format("D-MM-YYYY HH:mm");
  },
  renderAddHoursByTimezone(time, add_hour) {
    return moment
      .utc(time, "hh:mm:ssZ")
      .add(add_hour, "hours")
      .tz(store.getters.getUserCountry ? store.getters.getUserCountry.timezone_name : "Asia/Singapore")
      .format("HH:00");
  },
  renderAddHoursMinutesByTimezone(time, add_hour, add_min) {
    return moment
      .utc(time, "hh:mm:ssZ")
      .add(add_hour, "hours")
      .add(add_min, "minutes")
      .tz(store.getters.getUserCountry ? store.getters.getUserCountry.timezone_name : "Asia/Singapore")
      .format("HH:mm");
  },
  renderSubHoursByTimezone(time, add_hour) {
    return moment
      .utc(time, "hh:mm:ssZ")
      .subtract(add_hour, "hours")
      .tz(store.getters.getUserCountry ? store.getters.getUserCountry.timezone_name : "Asia/Singapore")
      .format("HH:00");
  },
  renderDateAddDuration(datetime, type, number, format) {
    return moment(datetime)
      .add(number, type)
      .format(format);
  },
  renderToHumanDate(datetime) {
    if (moment(datetime, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
      return moment(datetime, "YYYY-MM-DD HH:mm:ss").format("ddd, MMM Do YYYY, HH:mm");
    } else if (moment(datetime, "YYYY-MM-DD", true).isValid()) {
      return moment(datetime, "YYYY-MM-DD").format("ddd, MMM Do YYYY");
    } else if (moment(datetime, "DD-MM-YYYY HH:mm:ss", true).isValid()) {
      return moment(datetime, "DD-MM-YYYY HH:mm:ss").format("ddd, MMM Do YYYY, HH:mm");
    } else {
      return moment(datetime).format("ddd, MMM Do YYYY, HH:mm");
    }
  },
  renderCurrency(amount, currency_arr) {
    return amount.toLocaleString(currency_arr.locale, {
      style: "currency",
      currency: currency_arr.code,
      minimumFractionDigits: currency_arr.decimal_point,
    });
  },
  getHourOnly(datetime) {
    return moment
      .utc(datetime)
      .tz(store.getters.getUserCountry ? store.getters.getUserCountry.timezone_name : "Asia/Singapore")
      .format("HH");
  },

  initializeCountryCurrency(vm) {
    if (vm.$store.state.country.country_list.length < 1) {
      vm.$store.dispatch("initializeCountry", vm);
    }
  },
  convertToCountry(vm, number) {
    let is_symbol = number.substring(0, 1) == "+";

    if (is_symbol) {
      number = number.substring(1);
    }

    let country_code = number.substring(0, 2);
    let avail_countries = JSON.parse(JSON.stringify(vm.$store.state.contact_no_country_code));

    if (!avail_countries.includes(country_code)) {
      number = vm.$store.getters.getUserCountry.phone_code + number.substring(2);
    }

    return "+" + number;
  },
  changeCountrySelection(vm) {
    vm.$store.dispatch("changeCountrySelection", vm);
  },
  initializeGoodSize(vm) {
    vm.$store.dispatch("initializeGoodSize", vm);
  },
  initializeAddon(vm) {
    vm.$store.dispatch("initializeAddon", vm);
  },
  initializeServiceType(vm) {
    return vm.$store.dispatch("initializeServiceType", vm);
  },
  initializeOnDemandVehicleType(vm) {
    vm.$store.dispatch("initializeOnDemandVehicleType", vm);
  },

  initializePublic(vm) {
    this.initializeGoodSize(vm);
    this.initializeDeliveryType(vm);
  },
  initialize(vm, country) {
    // this.changeCountrySelection(vm)
    this.initializeServiceType(vm);
  },
  initializeOnDemand(vm) {
    this.initializeCountryCurrency(vm);
    this.initializeServiceType(vm);
  },
  isMobile() {
    return window.innerWidth <= 800;
  },
  setMyIPAddress(vm) {
    return vm.$store.dispatch("setMyIPAddress", vm);
  },
  renderWaybillText(delivery_type) {
    let sentence = i18n.t("createOrder.printParcelWaybill");

    if (delivery_type == store.state.enum_sameday || delivery_type == store.state.enum_ondemand) {
      sentence += ". " + i18n.t("createOrder.writeOrderNumber");
    } else if (delivery_type == store.state.enum_international) {
      sentence = i18n.t("createOrder.printInvoiceWaybill");
    }
    sentence += "!";

    return sentence;
  },
  showPrintWaybillDialog(vm, delivery_type, id, message) {
    let sentence = this.renderWaybillText(delivery_type);

    function onAcceptShowPrintWaybillDialog() {
      vm.$vs.notify({
        color: "warning",
        title: "VIAMOVE SYSTEM",
        text: sentence,
      });
    }

    if (id.substring(0, 1) == "#") {
      id = id.substring(1);
    }

    vm.$vs.dialog({
      color: "success",
      title: "#" + id,
      text: message ? message : i18n.t("createOrder.successCreate") + ". " + sentence,
      accept: onAcceptShowPrintWaybillDialog,
      acceptText: i18n.t("action.close"),
    });
  },
  countRecordIf(arr, arr_key) {
    let filter = arr.filter((item) => item[arr_key] == true);
    return filter.length ? filter.length : 0;
  },
  elapsedTime(startTime) {
    const x = new Date(startTime);
    const now = new Date();
    let timeDiff = now - x;
    timeDiff /= 1000;

    const seconds = Math.round(timeDiff);
    timeDiff = Math.floor(timeDiff / 60);

    const minutes = Math.round(timeDiff % 60);
    timeDiff = Math.floor(timeDiff / 60);

    const hours = Math.round(timeDiff % 24);
    timeDiff = Math.floor(timeDiff / 24);

    const days = Math.round(timeDiff % 365);
    timeDiff = Math.floor(timeDiff / 365);

    const years = timeDiff;

    if (years > 0) {
      return `${years + ` ` + i18n.tc("attribute.year", years) + ` ` + i18n.t("attribute.ago")}`;
    } else if (days > 0) {
      return `${days + ` ` + i18n.tc("attribute.day", days) + ` ` + i18n.t("attribute.ago")}`;
    } else if (hours > 0) {
      return `${hours + ` ` + i18n.tc("attribute.hour", hours) + ` ` + i18n.t("attribute.ago")}`;
    } else if (minutes > 0) {
      return `${minutes + ` ` + i18n.tc("attribute.minute", minutes) + ` ` + i18n.t("attribute.ago")}`;
    } else if (seconds > 0) {
      return `${seconds + ` ` + i18n.tc("attribute.second", seconds) + ` ` + i18n.t("attribute.ago")}`;
    }

    return "Just Now";
  },
  getKeyByValue(object, value) {
    let key = Object.keys(object).find((key) => object[key] === value);

    return key ? key : "";
  },
};
